import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services';

@Component({
  selector: 'debug-pricecalc',
  templateUrl: './debug-pricecalc.component.html',
})
export class DebugPriceCalcComponent implements OnInit {
  public pricelog: any;
  public pricelog_s: any;
  public pricelog_h: any;
  public pricelog_e: any;
  public orderNumber: string = null;
  public ohjobnumber: string = null;
  public sjorderNumber: string = null;
  public ecjobnumber: string = null;
  public isLoaded: boolean = false;

  constructor(private orderService: OrderService) {}

  ngOnInit() {
    this.orderNumber = null;
    this.sjorderNumber = null;
    this.ecjobnumber = null;
    this.ohjobnumber = null;
    this.pricelog = [];
    this.pricelog_s = [];
    this.pricelog_h = [];
    this.pricelog_e = [];
  }

  getPrice(e) {
    this.orderService.getlog(this.orderNumber).then((result) => {
      this.pricelog = result;
    });
  }

  getSPrice(e) {
    this.orderService.getlogsprice(this.sjorderNumber).then((result) => {
      this.pricelog_s = result;
    });
  }

  getOHMatching(e) {
    this.orderService.getlogohmatching(this.ohjobnumber).then((result) => {
      this.pricelog_h = result;
    });
  }

  getECMatching(e) {
    this.orderService.getlogecmatching(this.ecjobnumber).then((result) => {
      this.pricelog_e = result;
    });
  }
}
